import React, { useMemo } from "react";
import clsx from "classnames";
import makeStyles from "@material-ui/core/styles/makeStyles";
import theme from "styles/theme";
import { format, formatCurrency } from "lib/globalize-util";
import { ICellRendererParams } from "ag-grid-community";
import { IDetailsTotal } from "components/shipment-review/types";

export const PinnedDetailGridTotalsRowRenderer = (props: CastProp<ICellRendererParams, "data", IDetailsTotal>) => {
    const { column, data } = props;
    const value = useMemo(() => {
        const withCurrency = (x: number) => (data?.currency ? formatCurrency(x, data.currency.wholesale.code) : x);
        switch (column.getColId()) {
            case "shipment":
                return <div className="totals">{data.headerName || format("Totals")}</div>;
            case "totalQty":
                return <div className="quantity">{data?.quantity ?? 0}</div>;
            case "totalCost":
                return <div className="quantity">{withCurrency(data?.totalWholesalePrice ?? 0)}</div>;
            default:
                if (data.sizes?.[column.getColId()]) {
                    return <div className="quantity">{data.sizes[column.getColId()].quantity ?? 0}</div>;
                }
                return null;
        }
    }, [column, data]);

    const classes = useStyles();
    return <div className={clsx("pinnedCell", classes.root)}>{value}</div>;
};

const useStyles = makeStyles({
    root: {
        textAlign: "left",
        fontFamily: "Lato !important",
        "& .quantity": {
            marginTop: "7px",
            fontSize: "13px",
            height: "18px",
            fontWeight: "bold",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: "1",
            letterSpacing: "0.15px",
            textAlign: "right",
            color: theme.palette.darkerGrey,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
        "& .totals": {
            marginTop: "7px",
            fontSize: "12px",
            height: "18px",
            fontWeight: "bold",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: "1.5",
            letterSpacing: "0.16px",
            textAlign: "right",
            color: theme.palette.darkerGrey,
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
    },
});

export default PinnedDetailGridTotalsRowRenderer;
